import { defineMessages } from 'react-intl';

/** The copy of the pre-save screen (design presave-create a-d). */
export const presaveCreateMessages = defineMessages({
  crumb: { id: 'app.sml.presaveCreate.crumb', defaultMessage: 'Pre-save link' },
  crumbSong: { id: 'app.sml.presaveCreate.crumbSong', defaultMessage: 'Pre-save link for {title}' },
  close: { id: 'app.sml.presaveCreate.close', defaultMessage: 'Close' },
  eyebrow: { id: 'app.sml.presaveCreate.eyebrow', defaultMessage: 'Pre-save link' },

  question: { id: 'app.sml.presaveCreate.question', defaultMessage: 'Let fans save {title} before it is out.' },
  sub: {
    id: 'app.sml.presaveCreate.sub',
    defaultMessage: "Every pre-save lands in the fan's library on {date}. We build the page from your song.",
  },
  questionNoDate: { id: 'app.sml.presaveCreate.questionNoDate', defaultMessage: 'When does {title} come out?' },
  subNoDate: {
    id: 'app.sml.presaveCreate.subNoDate',
    defaultMessage: 'Pick the release day. Fans see a countdown, and their pre-saves land on that day.',
  },

  servicesLabel: { id: 'app.sml.presaveCreate.servicesLabel', defaultMessage: 'Fans pre-save on' },
  servicesCount: { id: 'app.sml.presaveCreate.servicesCount', defaultMessage: '{on} of {total} on' },
  servicesHint: {
    id: 'app.sml.presaveCreate.servicesHint',
    defaultMessage: 'Tap a service to leave it out. Keep at least one.',
  },
  serviceOn: { id: 'app.sml.presaveCreate.serviceOn', defaultMessage: '{service}, on' },
  serviceOff: { id: 'app.sml.presaveCreate.serviceOff', defaultMessage: '{service}, off' },

  create: { id: 'app.sml.presaveCreate.create', defaultMessage: 'Create pre-save link' },
  creating: { id: 'app.sml.presaveCreate.creating', defaultMessage: 'Creating your page' },
  publishNote: {
    id: 'app.sml.presaveCreate.publishNote',
    defaultMessage: 'The page goes live at once. You get the link to share on the next screen.',
  },
  tryAgain: { id: 'app.sml.presaveCreate.tryAgain', defaultMessage: 'Try again' },
  createFailed: {
    id: 'app.sml.presaveCreate.createFailed',
    defaultMessage: 'We could not make the page. Your song and your choices are safe. Try again in a moment.',
  },
  needsDateFirst: {
    id: 'app.sml.presaveCreate.needsDateFirst',
    defaultMessage: 'Save the release day first. A pre-save page needs a day of today or later.',
  },
  noCoverNote: {
    id: 'app.sml.presaveCreate.noCoverNote',
    defaultMessage: 'No cover yet: the page opens with the title and the countdown.',
  },

  cardHead: { id: 'app.sml.presaveCreate.cardHead', defaultMessage: 'From your song' },
  pillUpcoming: { id: 'app.sml.presaveCreate.pillUpcoming', defaultMessage: 'Upcoming' },
  pillLive: { id: 'app.sml.presaveCreate.pillLive', defaultMessage: 'Pre-save live' },
  pillOut: { id: 'app.sml.presaveCreate.pillOut', defaultMessage: 'Out' },
  noCover: { id: 'app.sml.presaveCreate.noCover', defaultMessage: 'No cover yet' },
  factReleaseDay: { id: 'app.sml.presaveCreate.factReleaseDay', defaultMessage: 'Release day' },
  factCover: { id: 'app.sml.presaveCreate.factCover', defaultMessage: 'Cover' },
  factCoverReady: { id: 'app.sml.presaveCreate.factCoverReady', defaultMessage: 'Ready' },
  factType: { id: 'app.sml.presaveCreate.factType', defaultMessage: 'Type' },
  factNoDay: { id: 'app.sml.presaveCreate.factNoDay', defaultMessage: 'No day yet' },
  factServices: { id: 'app.sml.presaveCreate.factServices', defaultMessage: 'Pre-save on' },
  change: { id: 'app.sml.presaveCreate.change', defaultMessage: 'Change' },
  editCover: { id: 'app.sml.presaveCreate.editCover', defaultMessage: 'Edit cover' },
  designCover: { id: 'app.sml.presaveCreate.designCover', defaultMessage: 'Design a cover' },
  uploadCover: { id: 'app.sml.presaveCreate.uploadCover', defaultMessage: 'Upload a file' },
  cardFoot: {
    id: 'app.sml.presaveCreate.cardFoot',
    defaultMessage: 'The page takes the title, the artist and the cover of this song.',
  },
  editSong: { id: 'app.sml.presaveCreate.editSong', defaultMessage: 'Edit the song' },

  dateLabel: { id: 'app.sml.presaveCreate.dateLabel', defaultMessage: 'Release day' },
  dateSave: { id: 'app.sml.presaveCreate.dateSave', defaultMessage: 'Save the day' },
  dateCancel: { id: 'app.sml.presaveCreate.dateCancel', defaultMessage: 'Cancel' },
  dateHint: {
    id: 'app.sml.presaveCreate.dateHint',
    defaultMessage: 'Saved on the song. Releases, the Studio and the song page use it too.',
  },
  datePast: { id: 'app.sml.presaveCreate.datePast', defaultMessage: 'Pick today or a later day.' },
  dateFailed: { id: 'app.sml.presaveCreate.dateFailed', defaultMessage: 'We could not save the day. Try again.' },

  createdTitle: { id: 'app.sml.presaveCreate.createdTitle', defaultMessage: 'Your pre-save link is live.' },
  createdSub: {
    id: 'app.sml.presaveCreate.createdSub',
    defaultMessage: 'Share it today. Every save is a fan who hears {title} on {date}, the moment it is out.',
  },
  copy: { id: 'app.sml.presaveCreate.copy', defaultMessage: 'Copy' },
  copied: { id: 'app.sml.presaveCreate.copied', defaultMessage: 'Copied' },
  share: { id: 'app.sml.presaveCreate.share', defaultMessage: 'Share' },
  open: { id: 'app.sml.presaveCreate.open', defaultMessage: 'Open' },
  nextFor: { id: 'app.sml.presaveCreate.nextFor', defaultMessage: 'Next for {title}' },
  nextKit: { id: 'app.sml.presaveCreate.nextKit', defaultMessage: 'Make the release kit' },
  nextKitBody: {
    id: 'app.sml.presaveCreate.nextKitBody',
    defaultMessage: 'Stories, posts and cover sizes in one look. A story with the pre-save link is in it.',
  },
  nextKitButton: { id: 'app.sml.presaveCreate.nextKitButton', defaultMessage: 'Open Studio' },
  nextEdit: { id: 'app.sml.presaveCreate.nextEdit', defaultMessage: 'Shape the page' },
  nextEditBody: {
    id: 'app.sml.presaveCreate.nextEditBody',
    defaultMessage: 'Add a video, your socials or a note to fans.',
  },
  nextEditButton: { id: 'app.sml.presaveCreate.nextEditButton', defaultMessage: 'Edit the page' },
  nextRelease: { id: 'app.sml.presaveCreate.nextRelease', defaultMessage: 'Open the release' },
  nextReleaseBody: {
    id: 'app.sml.presaveCreate.nextReleaseBody',
    defaultMessage: 'Plan the posts up to the day. The saves count shows there too.',
  },
  nextReleaseButton: { id: 'app.sml.presaveCreate.nextReleaseButton', defaultMessage: 'Open the release' },
  nextHome: { id: 'app.sml.presaveCreate.nextHome', defaultMessage: 'Your first release' },
  nextHomeBody: {
    id: 'app.sml.presaveCreate.nextHomeBody',
    defaultMessage: 'The checklist on Home ticks off the link and shows what is left.',
  },
  nextHomeButton: { id: 'app.sml.presaveCreate.nextHomeButton', defaultMessage: 'Back to Home' },
  createdFoot: {
    id: 'app.sml.presaveCreate.createdFoot',
    defaultMessage: 'You find the page in SmartLinks and on the song page.',
  },
  done: { id: 'app.sml.presaveCreate.done', defaultMessage: 'Done' },

  pickQuestion: { id: 'app.sml.presaveCreate.pickQuestion', defaultMessage: 'Which song do fans pre-save?' },
  pickSub: {
    id: 'app.sml.presaveCreate.pickSub',
    defaultMessage:
      'Pick a song that is not out yet. We build the page from it: the title, the cover and the release day.',
  },
  pickGroup: { id: 'app.sml.presaveCreate.pickGroup', defaultMessage: 'Coming out' },
  pickRow: { id: 'app.sml.presaveCreate.pickRow', defaultMessage: 'Pick' },
  pickHasPage: { id: 'app.sml.presaveCreate.pickHasPage', defaultMessage: 'Has a page' },
  pickNoDay: { id: 'app.sml.presaveCreate.pickNoDay', defaultMessage: 'No release day yet' },
  pickAddTitle: { id: 'app.sml.presaveCreate.pickAddTitle', defaultMessage: 'Add a new song' },
  pickAddBody: {
    id: 'app.sml.presaveCreate.pickAddBody',
    defaultMessage: 'The title, the day and a cover. It goes in your Catalog, and its pre-save page is one tap away.',
  },
  pickAddButton: { id: 'app.sml.presaveCreate.pickAddButton', defaultMessage: 'Add my song' },
  pickOut: { id: 'app.sml.presaveCreate.pickOut', defaultMessage: 'Out already? Fans can listen now.' },
  pickOutLink: { id: 'app.sml.presaveCreate.pickOutLink', defaultMessage: 'Make a SmartLink' },
  fansGetHead: { id: 'app.sml.presaveCreate.fansGetHead', defaultMessage: 'What fans get' },
  fansGetSave: { id: 'app.sml.presaveCreate.fansGetSave', defaultMessage: 'One tap saves the song before it is out' },
  fansGetCountdown: { id: 'app.sml.presaveCreate.fansGetCountdown', defaultMessage: 'A countdown to the release day' },
  fansGetLibrary: {
    id: 'app.sml.presaveCreate.fansGetLibrary',
    defaultMessage: 'The song in their library on day one',
  },
  emptyQuestion: { id: 'app.sml.presaveCreate.emptyQuestion', defaultMessage: 'Start with the song fans will save.' },
  emptySub: {
    id: 'app.sml.presaveCreate.emptySub',
    defaultMessage: 'Add your next release to the Catalog. It takes a minute, and the pre-save page is made from it.',
  },
  emptyCardBody: {
    id: 'app.sml.presaveCreate.emptyCardBody',
    defaultMessage: 'The title, the release day and a cover. Design the cover here, if you have none.',
  },

  hasPageQuestion: { id: 'app.sml.presaveCreate.hasPageQuestion', defaultMessage: '{title} has its pre-save link.' },
  hasPageSub: {
    id: 'app.sml.presaveCreate.hasPageSub',
    defaultMessage: 'Fans save it now and get it on release day. Share the link you have.',
  },
  hasPageNote: { id: 'app.sml.presaveCreate.hasPageNote', defaultMessage: 'One pre-save page per song.' },
  pickAnother: { id: 'app.sml.presaveCreate.pickAnother', defaultMessage: 'Pick another song' },
  outQuestion: { id: 'app.sml.presaveCreate.outQuestion', defaultMessage: '{title} is out. Fans can listen now.' },
  outSub: {
    id: 'app.sml.presaveCreate.outSub',
    defaultMessage: 'A pre-save is for a song before its release. Give fans one link to every service instead.',
  },
  missingQuestion: { id: 'app.sml.presaveCreate.missingQuestion', defaultMessage: 'We could not find this song.' },
  missingSub: {
    id: 'app.sml.presaveCreate.missingSub',
    defaultMessage: 'It is not in the Catalog of this artist any more. Pick another song for the pre-save.',
  },
  pickSong: { id: 'app.sml.presaveCreate.pickSong', defaultMessage: 'Pick a song' },

  lockLine: {
    id: 'app.sml.presaveCreate.lockLine',
    defaultMessage:
      'Pre-save links come with a paid plan. Fans who pre-save hear the song on day one, in their own library.',
  },
  seePlans: { id: 'app.sml.presaveCreate.seePlans', defaultMessage: 'See plans' },
  notNow: { id: 'app.sml.presaveCreate.notNow', defaultMessage: 'Not now' },
});
